import { useQuery } from 'react-query'
import kilometresUsage from '../../../assets/Speedometer.png'
import MainInfoUsage from "../MainInfoUsage/MainInfoUsage";


export default function PackageUsage() {
    const { data } = useQuery('getContractInfo')
    const percentageKilometersUsage = (totalAmount, currenctAmount) =>
        ((currenctAmount / totalAmount) * 100).toFixed(1)

    return (
        <MainInfoUsage
            myCardTitle='Χρήση Πακέτου'
            ImageWidth={280}
            ImageSrc={kilometresUsage}
            fontSize={22}
            TextOverImageInfo={`${percentageKilometersUsage(data.currentPackageDuration, data.kilometers)}%`}
            TextInfo={`Έχεις διανύσει το ${percentageKilometersUsage(data.currentPackageDuration, data.kilometers)}% των συνολικών χιλιομέτρων σου. Σου απομένουν ακόμα ${(data.currentPackageDuration - data.kilometers).toFixed(2)} χιλιόμετρα μέχρι τις ${data.endDate}.`}
            borderRadiusInfo={50}
            transform=' translate(90%,80%)'
            infoWidth={80}
            infoHeight={70}
            justifyContentTextInfo="center"
            paddingTopTextInfo={17}
            displayTextInfo="flex"
        />
    )
}


